import { useLoadDisplayTzPrefs } from "../hooks/useDisplayTz";

/**
 * Renders nothing. Loads the viewer's display timezone into the userPreferences
 * slice once, so every useDisplayTz() across the app reads a resolved zone
 * without each screen fetching it for itself.
 *
 * Mounted inside the authenticated shell, next to the app's other connectors.
 */
export function DisplayTzLoader(): null {
  useLoadDisplayTzPrefs();
  return null;
}
